import type { InputHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export type TextInputProps = {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

const inputBase = clsx(
  'w-full h-9 rounded-md outline-none',
  'border border-border bg-surface-card text-text-primary',
  'text-md placeholder:text-text-muted',
  'transition-[border-color,box-shadow] duration-fast',
  'hover:border-border-strong',
  'focus:border-border-focus focus:shadow-[0_0_0_3px_theme(colors.purple.100)]',
  'disabled:bg-ink-50 disabled:cursor-not-allowed disabled:opacity-70',
);

export function TextInput({ leftIcon, rightIcon, className, ...rest }: TextInputProps) {
  return (
    <span className="relative inline-flex w-full items-center">
      {leftIcon && (
        <span
          data-icon-slot="left"
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-text-muted"
        >
          {leftIcon}
        </span>
      )}
      <input
        className={clsx(
          inputBase,
          // The legacy used px-3 (12px) for the input gutter; pad more
          // when an icon occupies the slot.
          leftIcon ? 'pl-9' : 'pl-3',
          rightIcon ? 'pr-9' : 'pr-3',
          className,
        )}
        {...rest}
      />
      {rightIcon && (
        <span
          data-icon-slot="right"
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-text-muted"
        >
          {rightIcon}
        </span>
      )}
    </span>
  );
}
